<div class="modalBase w-100 change-password-modal" [class.active]="!currentPassword">
  @if (!currentPassword) {
    <span class="btn_Close" (click)="closeModal()">
      <i class="fas fa-times-circle"></i>
    </span>
  }

  <div class="change-password-modal__body">
    <div class="text-center mb-4">
      <span class="titulo">Cambiar contraseña</span>
      @if (forceChange) {
        <p class="change-password-force-hint">
          Debes establecer una nueva contraseña para continuar.
        </p>
      }
    </div>

    <form
      class="change-password-form"
      [formGroup]="changePasswordForm"
      (submit)="onSubmit()"
    >
      @if (errorMessage) {
        <ngb-alert class="mb-3" type="danger" (close)="errorMessage = ''">
          {{ errorMessage }}
        </ngb-alert>
      }

      @if (successMessage) {
        <ngb-alert class="mb-3" type="success" (close)="successMessage = ''">
          {{ successMessage }}
        </ngb-alert>
      }

      @if (currentPassword) {
        <div class="form-field">
          <label class="labeltext" for="currentpassword">Contraseña actual</label>
          <div class="password-input-wrapper">
            <input
              id="currentpassword"
              [type]="showCurrentPassword ? 'text' : 'password'"
              class="input_tx"
              placeholder="Ingresa tu contraseña actual"
              formControlName="currentpassword"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="password-toggle-btn"
              (click)="showCurrentPassword = !showCurrentPassword"
              [attr.aria-label]="showCurrentPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <i class="far" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          @if (
            changePasswordForm.controls.currentpassword.touched &&
            changePasswordForm.controls.currentpassword.errors?.required
          ) {
            <div class="texterror">Contraseña actual requerida</div>
          }
        </div>
      }

      <div class="form-field">
        <label class="labeltext" for="password">
          {{ currentPassword ? 'Contraseña nueva' : 'Contraseña' }}
        </label>
        <div class="password-input-wrapper">
          <input
            id="password"
            class="input_tx"
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Ingresa la nueva contraseña"
            formControlName="password"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="password-toggle-btn"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          >
            <i class="far" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        @if (
          (change && changePasswordForm.controls.password.errors?.required) ||
          (changePasswordForm.controls.password.touched &&
            changePasswordForm.controls.password.errors?.required)
        ) {
          <div class="texterror">Contraseña nueva requerida</div>
        }
        @if (
          changePasswordForm.controls.password.touched &&
          changePasswordForm.controls.password.errors?.minlength
        ) {
          <div class="texterror">La contraseña debe tener al menos 8 caracteres</div>
        }
      </div>

      <div class="form-field">
        <label class="labeltext" for="confirmpassword">Confirmar contraseña</label>
        <div class="password-input-wrapper">
          <input
            id="confirmpassword"
            class="input_tx"
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="Repite la nueva contraseña"
            formControlName="confirmpassword"
            autocomplete="new-password"
          />
          <button
            type="button"
            class="password-toggle-btn"
            (click)="showConfirmPassword = !showConfirmPassword"
            [attr.aria-label]="showConfirmPassword ? 'Ocultar confirmación' : 'Mostrar confirmación'"
          >
            <i class="far" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        @if (
          (change && changePasswordForm.controls.confirmpassword.errors?.required) ||
          (changePasswordForm.controls.confirmpassword.touched &&
            changePasswordForm.controls.confirmpassword.errors?.required)
        ) {
          <div class="texterror">Confirmar contraseña requerida</div>
        }
        @if (
          changePasswordForm.controls.confirmpassword.errors?.matchOther &&
          !changePasswordForm.controls.confirmpassword.errors?.required
        ) {
          <div class="texterror">Ambas contraseñas deben ser iguales</div>
        }
      </div>

      <div class="change-password-form__actions">
        <button
          type="submit"
          class="btn btn-outline-primary rounded-pill text-dark px-4 font-weight-bold"
        >
          Cambiar
        </button>
      </div>
    </form>
  </div>
</div>
